import { useMemo } from 'react';
import { useSearchParams } from 'react-router';

import { useLatest } from 'hooks/useLatest';
import type { SearchRefinementType } from 'modules/search/constants/refinements/searchRefinementTypes';
import {
  useSearchFiltersByName,
  useSearchRadius,
} from 'modules/search/contexts/SearchContext';
import type { SearchFiltersByName } from 'modules/search/types/FiltersByName/SearchFiltersByName';

export function useSearchSingleChoiceSelectedValue(
  refinementType: SearchRefinementType,
) {
  const [searchParams] = useSearchParams();

  const searchFiltersFromState = useSearchFiltersByName();
  const searchRadius = useSearchRadius();

  const selectedValue = useMemo(
    () => searchParams.get(refinementType) ?? '',
    [refinementType, searchParams],
  );

  const selectedValueRef = useLatest(selectedValue);

  const hasSearchFiltersFromState =
    searchFiltersFromState &&
    Array.isArray(Object.keys(searchFiltersFromState)) &&
    Object.keys(searchFiltersFromState).length > 0 &&
    !(
      Object.keys(searchFiltersFromState).length === 1 &&
      Object.keys(searchFiltersFromState).includes('type')
    );

  if (hasSearchFiltersFromState) {
    const searchSingleChoiceSelectedValue =
      searchFiltersFromState[refinementType as keyof SearchFiltersByName] ?? '';

    return searchSingleChoiceSelectedValue;
  }

  if (searchRadius && refinementType === 'radius') {
    return searchRadius;
  }

  return selectedValueRef.current;
}
